type FontStyle =
  | "title1"
  | "title2"
  | "title3"
  | "title4"
  | "headline"
  | "body"
  | "bodyEmphasis"
  | "subheadline"
  | "subheadlineEmphasis"
  | "caption"
  | "captionEmphasis"
  | "caption2"
  | "caption2Emphasis";

type FontFamily = "poppins";
type FontWeight = "regular" | "medium";

type FontMetrics = {
  family?: FontFamily;
  weight: FontWeight;
  size: number;
  lineHeight: number;
};

const fontFamilies: { [fontFamily in FontFamily]: string } = {
  poppins: "Poppins",
};

const fontFamily = (fontFamily: FontFamily | undefined): string => {
  if (fontFamily === undefined) {
    return "inherit";
  }

  return `"${fontFamilies[fontFamily]}", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`;
};

const fontWeights: { [fontWeight in FontWeight]: number } = {
  regular: 400,
  medium: 500,
};

const fonts: { [fontStyle in FontStyle]: FontMetrics } = {
  title1: { family: "poppins", weight: "regular", size: 34, lineHeight: 40 },
  title2: { family: "poppins", weight: "regular", size: 28, lineHeight: 32 },
  title3: { family: "poppins", weight: "regular", size: 22, lineHeight: 28 },
  title4: { family: "poppins", weight: "regular", size: 20, lineHeight: 24 },
  headline: { family: "poppins", weight: "regular", size: 18, lineHeight: 24 },
  body: { weight: "regular", size: 16, lineHeight: 24 },
  bodyEmphasis: { weight: "medium", size: 16, lineHeight: 24 },
  subheadline: { weight: "regular", size: 14, lineHeight: 20 },
  subheadlineEmphasis: { weight: "medium", size: 14, lineHeight: 20 },
  caption: { weight: "regular", size: 12, lineHeight: 16 },
  captionEmphasis: { weight: "medium", size: 12, lineHeight: 16 },
  caption2: { weight: "regular", size: 10, lineHeight: 12 },
  caption2Emphasis: { weight: "medium", size: 10, lineHeight: 12 },
};

const allFontStyles = Object.keys(fonts) as FontStyle[];

const fontStyles = allFontStyles.reduce((result, fontStyle) => {
  const metrics = fonts[fontStyle];
  const pxToRem = (px: number) => `${px / 16}rem`;
  result[fontStyle] = `
    font-family: ${fontFamily(metrics.family)};
    font-size: ${pxToRem(metrics.size)};
    font-weight: ${fontWeights[metrics.weight]};
    line-height: ${pxToRem(metrics.lineHeight)};
    letter-spacing: 0rem;
  `;
  return result;
}, {} as { [fontStyle in FontStyle]: string });

export default fontStyles;
